<section class="toggle-wrapper">
  <div *ngIf="agent"
  class="favourites is-flex has-flex-align-center"
  (click)="toggleFavouriteAgent(!agent.isFavourite)" tabindex="0" role="button"
  (keydown.enter)="toggleFavouriteAgent(!agent.isFavourite)" (focus)="onFocus.emit($event)">
    <img class="hide-on-mobile"
      [src]="('/assets/icons/heart/heart_icon' + (agent.isFavourite ? '_red@1x.svg' : '@1x.svg')) | staticp" height="17" width="18"
      [alt]="('agent-profile.' + (agent.isFavourite ? 'unfavourite' : 'favourite') + '-agent' ) | translate"/>
    <img class="hide-on-tablet-up"
      [src]="('/assets/icons/heart/heart_icon' + (agent.isFavourite ? '_red@1x.svg' : '_blue_white_filled@1x.svg')) | staticp" height="17" width="18"
      [alt]="('agent-profile.' + (agent.isFavourite ? 'unfavourite' : 'favourite') + '-agent' ) | translate"/>
    <span class="hide-on-mobile favourite-text" style="margin-left: 10px;" [translate]="'agent-profile.' + (agent.isFavourite ? 'unfavourite' : 'favourite') + '-agent' "></span>
  </div>
  <div *ngIf="showPopup" class="is-flex popup" [class.favourited]="!isLoggedIn || (agent.isFavourite || showConfirmation)">
    <div class="is-flex has-flex-align-center has-flex-content-center side-action hide-on-mobile" *ngIf="isLoggedIn">
      <img [src]="(agent.isFavourite ? '/assets/icons/heart/heart_icon_white_full@1x.svg' : '/assets/icons/heart/heart_icon_white@2x.svg') | staticp" height="18" width="18"
            [alt]="('agent-profile.' + (agent.isFavourite ? 'unfavourite' : 'favourite')+ '-agent') | translate"/>
    </div>
    <div class="content has-pos-rel" [class.filled]="!isLoggedIn">
      <span class="close-ic has-pos-abs" (click)="showPopup = false" role="button" tabindex="0" (keydown.enter)="showPopup = false">
        <i class="material-icons v-align">close</i>
      </span>
      <ng-container *ngIf="isLoggedIn">
        <span [translate]="'agent-profile.' + (agent.isFavourite ? 'favourited' : (showConfirmation ? 'update-favourite' : 'unfavourited')) + '-popup'" [translateParams]="{name: agent.firstName}"></span>
        <div class="is-flex has-flex-content-end confirmation" *ngIf="showConfirmation">
          <button class="btn btn-fake" translate="agent-profile.cancel" (click)="showConfirmation = false; showPopup = false;"></button>
          <button class="btn btn-fake" translate="agent-profile.continue" (click)="showConfirmation = false; toggleFavouriteAgent(!agent.isFavourite, true)"></button>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLoggedIn">
        <div class="wrapper">
          <h4 class="is-flex has-flex-content-center has-flex-align-center">
            <a (click)="onClick($event)" [routerLink]="['/', { outlets: { popup: 'register-login'} }]" class="is-flex has-flex-align-center">
              <span translate="my-remax.saved-searches.register-login"></span>
              <i class="material-icons">chevron_right</i>
            </a>
          </h4>
          <p class="text text-center" translate="my-remax.favourite-agent.login-prompt"></p>
        </div>
      </ng-container>
    </div>
  </div>
</section>
